import React from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";

interface ITitle {
  fontSize: string;
  fontWeight: string;
  color: string;
  underline?: boolean;
}

const Title = styled.button(
  ({ fontSize, fontWeight, color, underline }: ITitle) => ({
    fontSize: fontSize,
    fontWeight: fontWeight,
    color: color,
    cursor: "pointer",
    textDecoration: underline ? "underline" : "none",
  }),
);

type Props = {
  title: string;
  route?: string;
  replace?: boolean;
  fontSize?: string;
  fontWeight?: string;
  color?: string;
  underline?: boolean;
  onClick?: () => void;
};

const TitleNavigateButton = ({
  title,
  replace = true,
  route = "/",
  fontSize = "1.4rem",
  fontWeight = "400",
  color = "#808080",
  underline = false,
  onClick,
}: Props) => {
  const navigate = useNavigate();

  const navigatePage = (route: string, replace: boolean) => {
    if (!replace) {
      navigate(route, { replace: false });
    } else {
      navigate(route);
    }
  };

  return (
    <Title
      onClick={onClick ? onClick : () => navigatePage(route, replace)}
      fontSize={fontSize}
      fontWeight={fontWeight}
      underline={underline}
      color={color}>
      {title}
    </Title>
  );
};

export default TitleNavigateButton;
